import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes/components';
import { DefaultTemplate } from '../../../constants/templates';
import SourcesTabs from './components/SourcesTabs';
import BibframeTemplates from './components/bibTemplates';
import MarcTemplates from './components/MarcTemplates';
import Import from './components/Import';
import useQueryParams from '../../../hooks/useQueryParams';

const sources = {
  bibFrameTemplates: BibframeTemplates,
  marcTemplates: MarcTemplates,
  import: Import,
};

function ChooseSourceTypeModal({ onClose, open, basePath }) {
  const [sourceUrl, setSourceUrl] = useState(DefaultTemplate);
  const [currentTab, setCurrentTab] = useQueryParams(
    'source',
    'bibFrameTemplates',
  );

  const SourceComponent = sources[currentTab];

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="choose-instance-template-type-modal-accept-btn"
          buttonStyle="primary"
          to={`${sourceUrl}`}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.go"
            defaultMessage="Go"
          />
        </Button>
        <Button
          id="choose-instance-template-type-modal-cancel-btn"
          onClick={onClose}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  return (
    <Modal
      id="choose-instance-template-type-modal"
      open={open}
      onClose={onClose}
      footer={renderFooter()}
      label={
        <Icon icon="plus-sign" size="large">
          <FormattedMessage
            id="ui-plugin-inventory-templates.chooseTemplateType.modal.label"
            defaultMessage="Add new Instance"
          />
        </Icon>
      }
      dismissible
      size="large"
    >
      <SourcesTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <SourceComponent setSourceUrl={setSourceUrl} />
    </Modal>
  );
}

ChooseSourceTypeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  basePath: PropTypes.string.isRequired,
};

export default ChooseSourceTypeModal;
